import { useCallback, useState, useMemo, memo } from 'react';
import { IDeliveryPoint } from '@/shared/api/postDeliveryBoxberryPoints/types';
import PvzMapItem from '@/entities/PvzMapItem/ui/PvzMapItem';
import { Button } from '@/shared/ui/Button';
import { cvaAsideItems } from './PvzMapListItemsStyles';

interface Props {
  shops: IDeliveryPoint[];
  date: string;
  itemsCount: number;
  allItems: number;
  onClickPvz: (val: any) => void;
  pvzFilter: 'all' | 'pvz' | 'postamat';
  search: string;
}

interface List {
  data: IDeliveryPoint[];
  date: string;
  itemsCount: number;
  allItems: number;
  onClickPvz: (val: any) => void;
}

const STEP = 20;

const getFilteredByType = (shops: IDeliveryPoint[], pvzFilter: 'all' | 'pvz' | 'postamat') => {
  if (pvzFilter === 'all') {
    return shops;
  }

  return shops.filter(({ type }) => type === pvzFilter);
};

const getFilteredBySearch = (shops: IDeliveryPoint[], search: string) => {
  const str = search.trim().toLowerCase();
  if (str.length === 0) {
    return shops;
  }

  return shops
    .filter(({ address }) => address.trim().toLowerCase().includes(str))
    .sort((a, b) => a.address.localeCompare(b.address));
};

const Component = ({ data, date, itemsCount, allItems, onClickPvz }: List) => {
  if (data.length === 0) {
    return <div className="px-3.2">Не удалось ничего найти</div>;
  }

  return data?.map((item) => (
    <PvzMapItem
      data={item}
      key={item.code}
      address={item.address}
      icon={item.icon}
      type={item.type}
      date={date}
      workingHours={item.work_time}
      itemsCount={itemsCount}
      allItems={allItems}
      onClickPvz={onClickPvz}
    />
  ));
};

const List = memo(Component);

const PvzMapListItems = ({ pvzFilter, shops, date, itemsCount, allItems, onClickPvz, search }: Props) => {
  const [visibleCount, setVisibleCount] = useState(STEP);

  const onToggle = useCallback(() => {
    setVisibleCount((prev) => prev + STEP);
  }, []);

  const data = useMemo(() => {
    const filteredList = getFilteredBySearch(getFilteredByType(shops, pvzFilter), search) || [];
    const allCount = filteredList.length;

    return {
      list: filteredList.slice(0, visibleCount),
      allCount,
    };
  }, [shops, visibleCount, pvzFilter, search]);

  return (
    <div className={cvaAsideItems()}>
      <List data={data.list} date={date} itemsCount={itemsCount} allItems={allItems} onClickPvz={onClickPvz} />
      {data.allCount > visibleCount ? (
        <div className="p-2.4">
          <Button
            type="button"
            onClick={onToggle}
            className={'text-bodyMSemibold w-full'}
            rootWrapperClassName="w-full"
            animateWrapperClassName="w-full"
            size={'medium'}
            color={'mediumGreen'}
          >
            Показать ещё
          </Button>
        </div>
      ) : null}
    </div>
  );
};

export default PvzMapListItems;
